import { Icon } from '@amili-v3/amili-v3-design';

/**
 * Show/hide toggle for the auth cards' password fields. The design system's
 * default is a filled eye; the auth design uses the lighter stroked pair,
 * which takes its colour from `.ant-input-password-icon` in `AuthModal`.
 *
 * Pass to a password `ControlledInput` as `iconRender={authPasswordToggle}`.
 */
export const authPasswordToggle = (visible: boolean) => (
  <Icon
    name={visible ? 'eyeOutline' : 'eyeOutlineOff'}
    width={18}
    height={18}
    cursor="pointer"
  />
);

export default authPasswordToggle;
